import '@bnnvara/typography';

import { breakpoints } from '@bnnvara/breakpoints';
import styled from 'styled-components';

import appConfig from '../../config/app.json';

const StyledSubNavigation = styled.nav`
  position: sticky;
  top: ${({ brandHubHeight }) => appConfig.layout.hubHeight + brandHubHeight}px;
  z-index: 11;
  width: 100%;
  background-color: ${({ theme }) => theme.base.white};
  display: flex;
  justify-content: center;
  box-shadow: 0 1px 0 0 rgba(0, 0, 0, 0.04);

  ${breakpoints.md} {
    top: ${({ brandHubHeight }) =>
      appConfig.layout.hubHeightMd + brandHubHeight}px;
  }

  a {
    &:focus {
      outline: none;
    }
  }
`;

export default StyledSubNavigation;
